import { AfterViewInit, Directive, ElementRef, NgModule, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { asyncScheduler, filter, merge, observeOn, Subject, takeUntil, tap } from 'rxjs';

import { ItineraryState } from '@hiptraveler/data-access/itinerary';

@Directive({
  selector: '[hideIfEmpty]'
})
export class HideIfEmptyDirective implements AfterViewInit, OnDestroy {

  private subscription$ = new Subject<void>();

  constructor(
    private element: ElementRef<HTMLElement>,
    private store: Store
  ) { }

  ngAfterViewInit(): void {
    merge(
      this.store.select(ItineraryState.imageInformation),
      this.store.select(ItineraryState.hotelInformation)
    ).pipe(
      filter(Boolean),
      observeOn(asyncScheduler),
      tap(() => this.toggleVisibility()),
      takeUntil(this.subscription$)
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.subscription$.next();
  }

  /**
   * Shows or hides the host element depending on
   * whether it has at least one child node.
   */
  private toggleVisibility(): void {
    const host = this.element.nativeElement;
    host.style.display = host.children.length > 0 ? '' : 'none';
  }

}

@NgModule({
  declarations: [ HideIfEmptyDirective ],
  exports:      [ HideIfEmptyDirective ]
})
export class HideIfEmptyDirectiveModule { }

